import React from 'react'
import { Checkbox } from '@mui/material'

/** Header checkbox that only toggles the rows of the visible page (the MIT DataGrid always toggles every page). */
export default function GridPageSelectionCheckbox({ pageIds, selectedIds, disabled = false, onChange }) {
    const selectedOnPage = pageIds.filter((id) => selectedIds.has(id)).length
    const checked = pageIds.length > 0 && selectedOnPage === pageIds.length
    return (
        <Checkbox
            size='small'
            checked={checked}
            indeterminate={selectedOnPage > 0 && !checked}
            disabled={disabled || pageIds.length === 0}
            inputProps={{ 'aria-label': checked ? 'Unselect visible page' : 'Select visible page' }}
            onChange={() => onChange(!checked)}
            onClick={(event) => event.stopPropagation()}
        />
    )
}
